import { TicketQueries } from '@/graphql/queries/ticket.queries'
import { TicketDetail } from '@/types/Ticket'

import { useGraphql } from '../useGraphql'

const useTicket = (id: string | undefined) => {
  const ticketsQuery = useGraphql<{ ticket: TicketDetail }>(
    TicketQueries.QUERY_KEYS.getTicketDetail,
    TicketQueries.getTicketDetail(),
    { id: Number(id) },
    { enabled: !!id && !!Number(id) },
  )

  return ticketsQuery
}

export default useTicket
